import { loaderOptions } from "./googleMaps";
import { useJsApiLoader } from "@react-google-maps/api";

export const useGoogleMaps = () => {
  const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

  return { isLoaded, loadError };
};
